/* projects/speaker-platform/src/app/pages/admin/speaker-edit/speaker-edit.component.scss */
.speakeredit .nav.nav-tabs {
  font-size: 18px;
  font-weight: 500;
  --bs-nav-tabs-border-width: 0;
}
.speakeredit .nav.nav-tabs .nav-link {
  color: #818181;
}
.speakeredit .nav.nav-tabs .nav-link.active {
  color: #505050;
}
.speakeredit .nav.nav-tabs .nav-link.active::after {
  content: "";
  display: block;
  width: 50%;
  height: 2px;
  background-color: #FFED00;
}
.speakeredit__readonly {
  color: #952626;
}
.speakeredit__speakerslist {
  height: 70vh;
  overflow-y: scroll;
  margin-left: -20px;
}
/*# sourceMappingURL=speaker-edit.component-KNMEVXLE.css.map */
